import { render, staticRenderFns } from "./Account_Activation.vue?vue&type=template&id=b55a3f86&"
import script from "./Account_Activation.vue?vue&type=script&lang=js&"
export * from "./Account_Activation.vue?vue&type=script&lang=js&"
import style0 from "./Account_Activation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports